import { trpc } from "../../utils/trpc"

export const useDeleteTag = () => {
  const utils = trpc.useContext()
  return trpc.tags.delete.useMutation({
    onSuccess: () => {
      utils.tags.all.invalidate()
    },
  })
}